import apiProduct from '@/api/seller/slider';
import apiB2b from '@/api/seller/B2b';

const defaultState = () => ({
	sliderData: [],
	loadSlider: false,
	detailSlider: {},
	sliderPagination: '',
	response: {
		code: '',
		message: ''
	},
	responseError: {},
	alertMultiple: [],
	alert: ''
});

const state = defaultState();

const getters = {
};

const mutations = {
	setSlider(state, data) {
		state.sliderData = data.data
		state.sliderPagination = data.pagination;
	},
	setloadSlider(state, data) {
		state.loadSlider = data
	},
	setSliderDetail(state, data) {
		state.detailSlider = data
	},
	saveResponse(state, data) {
		state.response = data
		state.alertMultiple = []
		state.responseError = {}
		state.alert = ''
	},
	validationError(state, data) {
		state.responseError = data
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	failed(state, data) {
		state.alert = data
	},
	clearSlider(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	getSlider({ commit }, params) {
		commit('setloadSlider', true);
		return new Promise((resolve) => {
			apiProduct.getSlider(params).then(({ data: { data } }) => {
				commit('setSlider', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).catch(() => {
				commit('setSlider', { data: [], pagination: {} });
			}).then(() => {
				commit('setloadSlider', false);
			});
		});
	},
	
	getSliderDetail({ commit }, params) {
		commit('setloadSlider', true);
		return new Promise((resolve, reject) => {
			apiProduct.getSliderDetail(params).then(({ data: { data } }) => {
				commit('setSliderDetail', data.results);
				resolve(true);
			}).catch((err) => {
				const { data } = err.response;
				commit('makeAlert', { code: 'error_response', type: 'error', message: data.message, show: true }, { root: true });
				commit('setSliderDetail', {});
				reject(true)
			}).then(() => {
				commit('setloadSlider', false);
			});
		});
	},
	addSlider({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiProduct.addSlider(params).then(({ data }) => {
				dispatch('success', data)
				resolve(data.message);
			}).catch((err) => {
				const { data } = err.response;
				dispatch('errorHandler', data);
				reject(true)
			})
		});
	},
	updateSlider({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiProduct.updateSlider(params).then(({ data }) => {
				dispatch('success', data)
				resolve(true);
			}).catch((err) => {
				const { data } = err.response;
				dispatch('errorHandler', data);
				reject(true)
			})
		});
	},
	
	statusSlider({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiProduct.statusSlider(params).then(({ data }) => {
				dispatch('success', data)
				resolve(true);
			}).catch((err) => {
				const { data } = err.response;
				dispatch('errorHandler', data);
				reject(true)
			})
		});
	},
	removeSlider({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiProduct.removeSlider(params).then(({ data }) => {
				dispatch('success', data)
				resolve(true);
			}).catch((err) => {
				const { data } = err.response;
				dispatch('errorHandler', data);
				reject(true)
			})
		});
	},
	uploadImage({dispatch}, params) {
		return new Promise((resolve, reject) => {
			apiProduct.uploadImage(params).then(({ data: { data } }) => {
				resolve(data.results);
			}).catch((err) => {
				const { data } = err.response;
				dispatch('errorHandler', data);
				reject(true)
			})
		});
	},
	removeSliderImage({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiProduct.removeSliderImage(params).then(({ data }) => {
				dispatch('success', data)
				resolve(true);
			}).catch((err) => {
				const { data } = err.response;
				dispatch('errorHandler', data);
				reject(true)
			})
		});
	},
	async success({commit}, response) {
		await commit('saveResponse', response)
		await commit('makeAlert', { code: 'success', type: 'success', message: response.message, show: true }, { root: true });
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			case 'error_multiple_alert':
			commit('multipleAlert', response.data.error)
			break;

			default:
			commit('makeAlert', { code: 'error_response', type: 'error', message: response.message, show: true }, { root: true });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};